import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type UserlikeChatbotModuleSpecsFragment } from '../../../../api/fragments/UserlikeChatbotModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UserlikeChatbotModuleUpdateForm from './UserlikeChatbotModuleUpdateForm';

export type UserlikeChatbotUpdateModuleDrawerProps = {
    module: UserlikeChatbotModuleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const UserlikeChatbotUpdateModuleDrawer = ({ module, onClose, visible }: UserlikeChatbotUpdateModuleDrawerProps) => {
    const { t } = useTranslation(['userlikeChatbotModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('userlikeChatbotModuleDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updateUserlikeChatbotModule" htmlType="submit" type="primary">
                        {t('userlikeChatbotModuleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('userlikeChatbotModuleDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <UserlikeChatbotModuleUpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UserlikeChatbotUpdateModuleDrawer;

export const useUpdateUserlikeChatbotModuleDrawer = (module: UserlikeChatbotUpdateModuleDrawerProps['module']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <UserlikeChatbotUpdateModuleDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
